import { createLangLoader } from '@its-ui/mono/lang/private/createLangLoader';

const langs = import.meta.glob('./lang.*.json');

export const loadLangs = createLangLoader(
    (locale) => langs[`./lang.${locale}.json`]?.(),
    () => import('./lang.default.json')
);